module.exports = __webpack_public_path__ + "images/assets/5492ad7abb9ee3fa071fc717bd5e7db4.svg";